var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unindented-image"},[_c('YouTubeVideo',{attrs:{"video":_vm.video,"autoplay":_vm.autoplay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }